import { render, staticRenderFns } from "./rawMterialTiaozhuan.vue?vue&type=template&id=c16eab54&"
import script from "./rawMterialTiaozhuan.vue?vue&type=script&lang=js&"
export * from "./rawMterialTiaozhuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports